import React from 'react'
import './style.scss';
import Foleders from './components/Folders/Foleders';
import PresentationItems from './components/PresentationItems/PresentationItems';

function Sliders() {
  return (
    <div className="qbm-content SliderPage">
        <Foleders />
        <PresentationItems />
        {/* <div className="video_btn" onClick={() => {
          // this.props.showModal({
          //   modalType : MODAL_VIDE_INFO,
          //   modalProps : {
          //     titleModal: 'txtTitleVideoInfoPresentations',
          //     messageModal: 'txtMessageVideoInfoPresentations',
          //     videoUrl: './images/video_info/lecture_hall_tutorial.mp4'
          //   }
          // })
        }}><i className="fas fa-question"></i></div> */}
      </div>
  )
}

export default Sliders


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Sliders/Sliders.jsx